<script setup lang="ts">
import { ref } from 'vue';
import ToolTip from '../ToolTip.vue';
import { locale } from '../../locale';

const btn = ref<HTMLElement | null>(null)
</script>
<template>
  <button ref="btn" class="left-button">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6004 19.2L8.40039 12L15.6004 4.80001"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{locale.prevPage}}</ToolTip>
  </button>
</template>
<style scoped>
.left-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: rgba(73, 73, 73, 0.85);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
}

.left-button:disabled {
  pointer-events: none;
}
</style>
